import { useContext, useEffect, useMemo, useState } from "react";

import { AuthContext } from "shared/context/auth-context";
import { getTodayInTimezone } from "shared/utility/date";
import { isRideSkipUiEnabled } from "./constants";
import { useRideSkipApi } from "./useRideSkipApi";

export const useRideSkipSummary = (enabledOverride) => {
  const auth = useContext(AuthContext);
  const enabled = enabledOverride ?? isRideSkipUiEnabled(auth?.company);
  const { getSummary } = useRideSkipApi();
  const [rows, setRows] = useState([]);
  const today = getTodayInTimezone(auth?.company?.timezone || auth?.timezone, "yyyy-MM-dd");

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    getSummary(today).then((data) => {
      if (!cancelled) setRows(Array.isArray(data?.summary) ? data.summary : []);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled, today, getSummary]);

  const counts = useMemo(() => {
    const map = {};
    for (const row of rows) {
      map[`${row.serviceKind}:${row.serviceId}`] = row.count;
    }
    return map;
  }, [rows]);

  return { enabled, counts, today };
};
